import makeMoment from '../../moment/MomentFactory';
import LocalizationService from '~/zf/frontend/common/localization/LocalizationService';
import MomentFormat from '~/zf/frontend/common/moment/MomentFormat';
function makeTimezoneInformation(dateTime) {
    return `(${dateTime.tz()} ${dateTime.format('Z')})`;
}
function fromToFormatter(timestampFrom, timestampTo) {
    const from = LocalizationService.convertTimezoneFromUtcToUser(timestampFrom);
    const to = LocalizationService.convertTimezoneFromUtcToUser(timestampTo);
    return `${LocalizationService.localizeDateTimeFormat(from, MomentFormat.LOCALE_SHORT_TIME)} - ${LocalizationService.localizeDateTimeFormat(to, MomentFormat.LOCALE_SHORT_TIME)}`;
}
function dateTimePastFormatter(timestamp) {
    const now = makeMoment.utc();
    const lastUpdatedOn = makeMoment.utc(timestamp);
    if (now.diff(lastUpdatedOn, 'days') >= 7) {
        return LocalizationService.localizeDateTimeFormat(lastUpdatedOn, MomentFormat.LOCALE_LONG);
    }
    return lastUpdatedOn.fromNow();
}
function dateTimePastTooltipFormatter(timestamp, timezone) {
    const lastUpdatedOn = makeMoment
        .utc(timestamp)
        .tz(timezone);
    return `${LocalizationService.localizeDateTimeFormat(lastUpdatedOn)} ${makeTimezoneInformation(lastUpdatedOn)}`;
}
const TimeHelperService = {
    fromToFormatter,
    dateTimePastFormatter,
    dateTimePastTooltipFormatter,
};
export default TimeHelperService;
